module.exports = __webpack_public_path__ + "static/media/295203.6b7dfb38.png";